module.exports = __webpack_public_path__ + "cg.svg?5637992e76d5a600b5519987f82e1114";